import React,{ useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AuthLayout from '../../layouts/AuthLayout/AuthLayout';

import './ResetPassword.scss';
import { resetPassword } from '../../services/users';

import BeatLoader from "react-spinners/BeatLoader";

import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const override = {
    textAlign: 'center',
    marginTop: '20px'
  };

const index = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [email, setEmail] = useState(null);

    const handleResetPassword = () => {
        // VALIDATE EMAIL  BEFORE PROCEEDING
        if(email.length < 5) {
            setErrorMessage("Enter a valid email");
            setTimeout(() => {
                setErrorMessage("");
            }, 5000);
            return;
        }
        setIsLoading(true);
            resetPassword(email).then(res => {
                toast.success("Reset Password Email Sent Successfuly", {
                    pauseOnHover: false,
                    closeOnClick: true,
                  })
                  setEmail("");
                  setIsLoading(false);
           }).catch(err => {
                toast.error("Failed To Reset Password", {
                    pauseOnHover: false,
                    closeOnClick: true,
                  })
                setIsLoading(false);
            })
    }
  return (
    <AuthLayout pageName="reset-password">
      <div className="login-form">
      <BeatLoader
          color="#36d7b7" 
          loading={isLoading}
          cssOverride={override}
        />
      <div className="login-error">{ errorMessage ? errorMessage : ''}</div>
            <div className={`field`}>
              <label htmlFor="email">email</label>
              <input
                name="email"
                id="email"
                placeholder="Enter Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <button className="reset-btn" disabled={isLoading} onClick={handleResetPassword}>
                Reset Password
            </button>
      <p>
        Login ? <Link to={"/login"}>Here</Link>
      </p>
    </div>
    </AuthLayout>
  );
};

export default index;
